<template>

  <div id="app">
    <title-container :title="'My24 Account'"></title-container>

    <router-view></router-view>
  </div>

</template>

<script>
  import { TitleContainer } from 'my-account-common-vue'
  export default {
    components: {
      TitleContainer
    },
    name: 'app'
  }
</script>

<style lang="scss">
  $fa-font-path: "~font-awesome/fonts";
  @import "~font-awesome/scss/font-awesome";
  @import "~material-design-icons-iconfont/dist/fonts/material-icons.css";
</style>



// WEBPACK FOOTER //
// src/App.vue